import React from 'react';
import TrackingLinksPage from '../components/TrackingLinksPage';

const TrackingLinksApp = (props) => <TrackingLinksPage {...props} />;
export default TrackingLinksApp;
